import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';


//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { mkConfig, generateCsv, download } from "export-to-csv";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer, toast } from "react-toastify";
import { get, post } from "helpers/api_helper"; 

import { formatDate } from "helpers/date_helper";
import moment from "moment";
import { setSystemError, setSystemLoading, getCities as onGetCities, } from "store/actions";
import { useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

import DeleteModal from "../../components/Common/DeleteModal"; // Adjust the path if needed


import { FaTrash } from "react-icons/fa"; 

function FailedCarts() {

  //meta title
  document.title = "Master >> Failed Carts";
  const [failedCarts, setFailedCarts] = useState([]);
  const [totalFailedCarts, setTotalFailedCarts] = useState(0);
  const [query, setQuery] = useState("");
  const [limit, setLimit] = useState(10);
  const [city, setCity] = useState("All");
  const [isLoading, setLoading] = useState(true)
  const [pageNumber, setPage] = useState(1);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedOrderId, setSelectedOrderId] = useState(null);

  const dispatch = useDispatch();

  const fetchFailedCarts = async () => {
    try {
      dispatch(setSystemLoading(true));
      const res = await get(`orders/failed-carts?page=${pageNumber}&limit=${limit}&query=${query}&city=${city}`);
      setFailedCarts(res?.orders);
      console.log("response",res);
      setTotalFailedCarts(res?.totalOrders);
      setLoading(false);
      dispatch(setSystemLoading(false));
      dispatch(setSystemError(false));
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      let errorMessage = !error?.response ? "No internet connection. Please check your network settings and try again." : (error?.response?.data?.message || "Something went wrong");
      dispatch(setSystemError(errorMessage));
    }
  }

const handleDelete = (_id) => {
  setSelectedOrderId(_id);
  setShowDeleteModal(true);
};

const handleDeleteConfirmed = async () => {
  try {

    const payload = { _id: selectedOrderId }; 
    const response = await post(`/orders/delete-failed-carts`, payload); 
    const successMessage = response?.data?.message || "Deleted successfully";
    toast.success(successMessage);
    fetchFailedCarts(); 
  } catch (error) {
    console.error("Delete error", error);
    const errorMessage = error?.response?.data?.message || "Failed to delete the cart.";
    toast.error(errorMessage);
  } finally {
    setShowDeleteModal(false);
    setSelectedOrderId(null);
  }
};

  useEffect(() => {
    setLoading(true);
    fetchFailedCarts();
  }, [pageNumber, limit, query, city]);

  const csvConfig = mkConfig({ useKeysAsHeaders: true });

  const exportToCSVButtonClicked = async () => {
    try {
      const res = await get(`orders/failed-carts?query=${query}&csvTrue=${true}${city ? `&city=${city}`: ''}`);
      if (res.success === false) {
        toast.error("Error in exporting data");
        return;
      }
      const csvData = res?.orders?.map((order) => {
        return {
          orderId: order?.orderId,
          customerName: order?.customer?.fname + " " + order?.customer?.lname,
          mobile: order?.customer?.mobile,
          toy_name: order?.toy?.name,
          city: order?.city?.name,
          zone: order?.customer?.zone?.name ? order?.customer?.zone?.name : "Not Available",
          pincode: order?.customer?.pincode,
          orderDate: formatDate(order?.createdAt),
          deliveryDate: formatDate(order?.deliveryDate),
          returnDate: formatDate(order?.returnDate),
          orderTotal: order?.orderTotal,
          paymentAmount: order?.paymentDetails?.amount,
          paymentStatus: order?.paymentDetails?.status,
          duration: (order?.duration * 7) + " days",
          paid: order?.paid,
          selfPickup: order?.selfPickup ? "Yes" : "No",
        };
      });
    
     

      if (csvData.length === 0) {
        toast.error("No data to export");
        return;
      }

      const csv = generateCsv(csvConfig)(csvData);
      download(csvConfig)(csv)

    } catch (error) {
      toast.error("Error in exporting data");
      console.log("Error in exporting data", error);
    }
  }

  const selectCityState = (state) => state.City;
  const CityProperties = createSelector(
    selectCityState,
    (City) => ({
      cities: City.cities
    })
  );

  const { cities } = useSelector(CityProperties);

  useEffect(() => {
    dispatch(onGetCities());
  }, [dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: 'Order ID',
        accessor: "orderId",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: ({ row }) => {
          return <>{row?.original?.orderId ?? " "} </>;
        },
      },
      {
        Header: 'Customer Name',
        accessor: 'name',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.fname?.charAt(0).toUpperCase() + cellProps?.row?.original?.customer?.fname?.slice(1) + " " + cellProps?.row?.original?.customer?.lname?.charAt(0).toUpperCase() + cellProps?.row?.original?.customer?.lname?.slice(1)}
          </>;
        }
      },
      {
        Header: 'Mobile',
        accessor: 'mobile',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.mobile}
          </>;
        }
      },
      {
        Header: 'Toy Pic',
        accessor: 'toy_pic',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            <img src={cellProps?.row?.original?.toy?.defaultPhoto} alt="toyImage" className="avatar-sm" />          </>;
        }
      },
      {
        Header: 'Toy Name',
        accessor: 'toy_name',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.toy?.name}
          </>;
        }
      },
      {
        Header: 'City',
        accessor: 'city',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
           {cellProps?.row?.original?.city?.name}
          </>;
        }
      },
      {
        Header: 'Zone',
        accessor: 'zone',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.zone?.name ? cellProps?.row?.original?.customer?.zone?.name : "Not Available"}
          </>;
        }
      },
      {
        Header: 'Pin Code',
        accessor: 'pincode',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.pincode}
          </>;
        }
      },
      {
        Header: 'Order Date',
        accessor: 'createdAt',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {formatDate(cellProps?.row?.original?.createdAt)}
          </>;
        }
      },
      {
        Header: 'Delivery Date',
        accessor: 'deliveryDate',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {formatDate(cellProps?.row?.original?.deliveryDate)}
          </>;
        }
      },
      {
        Header: 'Return Date',
        accessor: 'returnDate',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {formatDate(cellProps?.row?.original?.returnDate)}
          </>;
        }
      },
      {
        Header: 'Amount',
        accessor: 'paymentAmount',
        width: '120px',
        style: {
          textAlign: "center",
          width: "8%",
          background: "#0000",
        },
        filterable: false,
        Cell: (cellProps) => {
          const amount = cellProps?.row?.original?.paymentDetails?.amount;
          return <>
            {amount ? `₹${amount}` : cellProps?.row?.original?.orderTotal ? `₹${cellProps?.row?.original?.orderTotal}` : '—'}
          </>;
        }
      },
      {
        Header: 'Payment Status',
        accessor: 'paymentStatus',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: false,
        Cell: (cellProps) => {
          const status = cellProps?.row?.original?.paymentDetails?.status;
          const badgeColor = status === 'failed' ? '#dc3545' : status === 'authorized' ? '#fd7e14' : '#6c757d';
          return status ? (
            <span style={{
              backgroundColor: badgeColor,
              color: '#fff',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '11px',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {status}
            </span>
          ) : <span style={{ color: '#6c757d' }}>—</span>;
        }
      },
      {
        Header: "Action",
        accessor: "action",
        width: "100px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        Cell: ({ row }) => {
          return (
            <FaTrash
              className="text-danger"
              style={{ cursor: "pointer" }}
               onClick={() => handleDelete(row?.original?._id)}
              title="Delete Failed Cart"
            />
          );
        }
      }
      
    ],
    []
  );

 

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Failed-Carts" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    title="Age Group"
                    columns={columns}
                    data={failedCarts || []}
                    csvExport={true}
                    exportToCSVButtonClicked={exportToCSVButtonClicked}
                    isCityFilter={true}
                    cities={cities}
                    city={city}
                    setCity={setCity}
                    // isGlobalFilter={true}
                    isCustomGlobalFilter={true}
                    setQuery={setQuery}
                    // isAddOptions={true}
                    handleOrderClicks={() => { }}
                    customPageSize={10}
                    isPagination={false}
                    filterable={false}
                    iscustomPageSizeOptions={true}
                    tableClass="align-middle table-nowrap table-check"
                    theadClass="table-light"
                    pagination="pagination pagination-rounded justify-content-end mb-2"
                    isCustomPagination={true}
                    setPage={setPage}
                    pageNumber={pageNumber}
                    totals={totalFailedCarts}
                    setLimit={setLimit}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <DeleteModal
        show={showDeleteModal}
        title="failed cart"
        onCloseClick={() => setShowDeleteModal(false)}
        onDeleteClick={handleDeleteConfirmed}
      />

      <ToastContainer />
    </React.Fragment>
  );
}
FailedCarts.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default FailedCarts;